"use client";
import f from "styled-components";
import t, { useState as u } from "react";
import "./index.es73.js";
import "./index.es74.js";
import "./index.es75.js";
import "./index.es76.js";
import "./index.es77.js";
import "./index.es78.js";
import "./index.es79.js";
import "./index.es80.js";
import "./index.es81.js";
import "./index.es83.js";
import "./index.es84.js";
import "./index.es85.js";
import "./index.es86.js";
import "./index.es87.js";
import "./index.es88.js";
import "./index.es89.js";
import "./index.es90.js";
import k from "./index.es91.js";
import "./index.es92.js";
import "./index.es93.js";
import "./index.es94.js";
import "./index.es95.js";
import "./index.es96.js";
import "./index.es176.js";
import x from "./index.es177.js";
import "./index.es178.js";
import "./index.es179.js";
import "./index.es180.js";
import "./index.es181.js";
import "./index.es182.js";
import "./index.es183.js";
const y = f.div`
  position: absolute;
  left: -9999px;
  top: -9999px;
  width: 900px;
`, V = ({
  type: r,
  data: a,
  options: n,
  filename: l,
  dataId: m,
  screenReaderText: i
}) => {
  const [p, d] = u(null), c = (o) => {
    d(o);
  }, s = (o) => {
    if (o.preventDefault(), p) {
      const e = document.createElement("a");
      e.href = p.toBase64Image(), e.download = l, e.click();
    }
  };
  return /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(
    x,
    {
      title: i,
      iconName: "download",
      onClick: s
    },
    "Last ned bilde",
    /* @__PURE__ */ t.createElement("span", { className: "bl-sr-only" }, i)
  ), /* @__PURE__ */ t.createElement(y, null, /* @__PURE__ */ t.createElement(
    k,
    {
      key: `${m}-chart-download`,
      onChartChange: c,
      type: r,
      data: a,
      options: n,
      keyContext: `statistics-block-download-${m}-${r}`
    }
  )));
};
export {
  V as default
};
//# sourceMappingURL=index.es276.js.map
